import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { StopTargets, SubTaskItem, TaskTarget, SubTasksMethod, TaskStopSubTasksRequestData, SubTasksStopSubTasksResponseData } from '../types';

export class SubTasksBaseDataProvider extends BaseWebComponentDataProvider {
  private endpoint = 'Tasks';
  private dataProviderType = DataProviderType.ENDPOINTS;

  public async getDataForView() {
    return {};
  }

  public async createTasks(records: Array<SubTaskItem>, taskType: number, taskName : string): Promise<SubTasksStopSubTasksResponseData> {

    const targets: TaskTarget[] = [];
    const stopTargets: Array<StopTargets> = [];

    records.forEach((record: SubTaskItem) => {
      const target = record.targets;

      stopTargets.push({
        name: target[0]['name'],
        protectedEntityId: target[0]['protectedEntityId'],
        type: target[0]['type'],
        taskId: record['_id'],
        taskType: record['type'],
        taskProgress: record['progress'],
        taskStatus: record['status']
      });

      targets.push({
        name: target[0]['name'],
        protectedEntityId: target[0]['protectedEntityId'],
        type: target[0]['type'],
        company: {
          id: record.companies[0].id,
          name: record.companies[0].name,
        }
      })
    });

    const payload: TaskStopSubTasksRequestData = {
      settings: {
        specifics: {
          stopTargets: stopTargets
        },
        targets: targets,
        taskName: taskName,
        type: taskType
      }
    };

    return ConsoleRequest.createRequest<SubTasksStopSubTasksResponseData>({
      dataProviderType: this.dataProviderType,
      payload: payload,
      endpoint: this.endpoint,
      method: SubTasksMethod.CREATE_TASKS,
    });
  }

}
